// import Vue from 'vue'
// import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer');

const lifeClass = () => import('@/views/basic/lifeClass');
const lifePerson = () => import('@/views/basic/lifePerson');
const lifeClassImport = () => import('@/views/basic/component/personImport');
const studyYear = () => import('@/views/study/studyYear');
const studyPerson = () => import('@/views/study/studyPerson');
const book = () => import('@/views/exam/book');
const bookList = () => import('@/views/exam/bookList');
const bookImport = () => import('@/views/exam/component/bookImport');
const bookListImport = () => import('@/views/exam/component/bookListImport');
const addPoints = () => import('@/views/exam/addPoints');
const addPointsApply = () => import('@/views/exam/addPointsApply');
const recitePoints = () => import('@/views/score/recitePoints');
const person = () => import('@/views/basic/person');
const personStudy = () => import('@/views/basic/personStudy');
const personEducation = () => import('@/views/basic/personEducation');
const orderByYear = () => import('@/views/orderBy/orderByYear');
const orderByStudyYear = () => import('@/views/orderBy/orderByStudyYear');
const user = () => import('@/views/user/user');
const eventsLog = () => import('@/views/EventsLog');

// Views - Pages
const Dashboard = () => import('@/views/Dashboard');
const Page404 = () => import('@/views/common/Page404');
const Page500 = () => import('@/views/common/Page500');
const Login = () => import('@/views/common/Login');
const Register = () => import('@/views/common/Register');

export default [
  {
    path: '/',
    redirect: '/dashboard',
    name: '首頁',
    component: TheContainer,
    meta: {
      auth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: ''
            },
          ]
        },
      },
      {
        path: 'person',
        name: '人員資料管理',
        component: person,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '人員資料管理'
            },
          ]
        },
      },
      {
        path: 'personStudy',
        name: '學員資料管理',
        component: personStudy,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學員資料管理'
            },
          ]
        },
      },
      {
        path: 'personEducation',
        name: '個人修習紀錄',
        component: personEducation,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學員資料管理'
            },
            {
              name: '個人修習紀錄'
            },
          ]
        },
      },
      {
        path: 'lifeClass',
        name: '生活班管理',
        component: lifeClass,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '生活班管理'
            },
          ]
        },
      },
      {
        path: 'lifePerson',
        name: '生活班員管理',
        component: lifePerson,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '生活班管理'
            },
            {
              name: '班員管理'
            },
          ]
        },
      },
      {
        path: 'lifeClassImport',
        name: '人員匯入',
        component: lifeClassImport,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '生活班管理'
            },
            {
              name: '人員匯入'
            },
          ]
        },
      },
      {
        path: 'studyYear',
        name: '學制班管理',
        component: studyYear,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學制班管理'
            },
          ]
        },
      },
      {
        path: 'studyPerson',
        name: '班員及成績管理',
        component: studyPerson,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學制班管理'
            },
            {
              name: '班員及成績管理'
            },
          ]
        },
      },
      {
        path: 'book',
        name: '書目管理',
        component: book,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '書目管理'
            },
          ]
        },
      },
      {
        path: 'bookImport',
        name: '書目匯入',
        component: bookImport,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '書目管理'
            },
            {
              name: '書目匯入'
            },
          ]
        },
      },
      {
        path: 'bookListImport',
        name: '書目分格匯入',
        component: bookListImport,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '書目管理'
            },
            {
              name: '書目分格匯入'
            },
          ]
        },
      },
      {
        path: 'bookList',
        name: '書目與分格管理',
        component: bookList,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '書目管理'
            },
            {
              name: '書目與分格管理'
            },
          ]
        },
      },
      {
        path: 'addPoints',
        name: '加分考範圍',
        component: addPoints,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學制班管理'
            },
            {
              name: '班員及成績管理'
            },
            {
              name: '加分考範圍'
            },
          ]
        },
      },

      {
        path: 'addPointsApply',
        name: '加分考報考',
        component: addPointsApply,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學制班管理'
            },
            {
              name: '班員及成績管理'
            },
            {
              name: '加分考範圍'
            },
          ]
        },
      },
      {
        path: 'recitePoints',
        name: '背書成績管理',
        component: recitePoints,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '學制班管理'
            },
            {
              name: '班員及成績管理'
            },
            {
              name: '背書成績管理'
            },
          ]
        },
      },
      {
        path: 'orderByYear',
        name: '統計排名',
        component: orderByYear,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '統計排名'
            },
          ]
        },
      },
      {
        path: 'orderByStudyYear',
        name: '統計排名學制班',
        component: orderByStudyYear,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '統計排名'
            },
            {
              name: '學制班'
            },
          ]
        },
      },
      {
        path: 'user',
        name: '使用者帳號管理',
        component: user,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '使用者帳號管理'
            },
          ]
        },
      },
      {
        path: 'eventsLog',
        name: '系統記錄查詢',
        component: eventsLog,
        meta: {
          role:['ROLE_ADMIN', 'ROLE_USER'],
          breadcrumb: [
            {
              name: '首頁',
              link: '/'
            },
            {
              name: '系統記錄查詢'
            },
          ]
        },
      },
    ]
  },
  {
    path: '/common',
    redirect: '/common/404',
    name: 'Common',
    component: {
      render(c) { return c('router-view'); }
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'register',
        name: 'Register',
        component: Register
      }
    ]
  }
];

// Vue.use(Router)

// export default new Router({
//   mode: 'hash', // https://router.vuejs.org/api/#mode
//   linkActiveClass: 'active',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: configRoutes()
// })

// function configRoutes () {
//   return [
//     {
//       path: '/',
//       name: 'Home',
//       component: TheContainer,
//       children: [
//       ]
//     },
//     {
//       path: '/pages',
//       redirect: '/pages/404',
//       name: 'Pages',
//       component: {
//         render (c) { return c('router-view') }
//       },
//       children: [
//         {
//           path: '404',
//           name: 'Page404',
//           component: Page404
//         },
//         {
//           path: '500',
//           name: 'Page500',
//           component: Page500
//         },
//         {
//           path: 'login',
//           name: 'Login',
//           component: Login
//         },
//         {
//           path: 'register',
//           name: 'Register',
//           component: Register
//         }
//       ]
//     }
//   ]
// }

